module.exports = __webpack_public_path__ + "img/fallback-slide-notext.2560x2560.2bd46e7a.png";